module.exports = __webpack_public_path__ + "static/2f9cf697.tmallClose_1.png";